// Helpers for parsing and linking to user-submitted document files.
// `submitted_file_path` in the DB may be a JSON array of paths (multi-file
// submissions) OR a plain string (legacy single-file). These helpers handle
// both shapes transparently.

const DOWNLOAD_ENDPOINT = 'https://renaisons.com/api/download_user_document.php';

export function parseSubmittedPaths(rawPath) {
    if (!rawPath || typeof rawPath !== 'string') return [];
    const trimmed = rawPath.trim();
    if (!trimmed) return [];
    if (trimmed.startsWith('[')) {
        try {
            const arr = JSON.parse(trimmed);
            if (Array.isArray(arr)) {
                return arr.filter(p => typeof p === 'string' && p.length > 0);
            }
        } catch (e) {
            // fall through to legacy single-string handling
        }
    }
    return [trimmed];
}

export function buildDownloadUrl(docId, index = 0) {
    const params = new URLSearchParams({ doc_id: String(docId) });
    if (index > 0) params.set('index', String(index));
    return `${DOWNLOAD_ENDPOINT}?${params.toString()}`;
}

// Returns the count of submitted files. 0 if none.
export function submittedFileCount(rawPath) {
    return parseSubmittedPaths(rawPath).length;
}

export const ALLOWED_FILE_EXTENSIONS = ['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png'];
export const ALLOWED_FILE_ACCEPT = ALLOWED_FILE_EXTENSIONS.join(',');

export function isAllowedFile(file) {
    if (!file || !file.name) return false;
    const ext = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
    return ALLOWED_FILE_EXTENSIONS.includes(ext);
}
